import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import InputDesign from './InputDesign';
import CardContainer from './CardContainer';
import { useStyles } from './styles';
import { Grid } from '@material-ui/core';
import { AuthContext } from '../../../../providers/AuthProvider';


const AIHomePage: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const onExplore = () => {
    navigate('/ai-in-sdlc');
  };
  const authContext = useContext(AuthContext);
  const subtitle = authContext && authContext.profEmail && `Hey ${authContext.profEmail.split('@')[0].split('.')[0]}! we're excited to share`;
  return <Grid className={styles.aiHomePageContainer}>
    <div className={styles.aiHomeBackgroundLines}/>
    <div className={styles.aiHomeBackgroundLines2}/>
    {/* <div className={styles.aiHomeBackgroundLines3}/> */}
    <Grid xs={12} md={12} lg={3} className={styles.aiHomeInputContainer}>
      <InputDesign onExplore={onExplore} subtitle={subtitle}/>
    </Grid>
    <Grid xs={12} md={12} lg={9}>
      <CardContainer/>
    </Grid>
  </Grid>
};

export default AIHomePage;
